import { observer } from 'mobx-react-lite'
import { IconCopyButton, SpinnerLoader, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { DayjsFormats } from 'shared/lib'
import { MessageContent } from 'widgets/DetailsContent'
import { type MessageDetailsModalStore } from 'widgets/MessageCard/ui/MessageDetailsModal'
import styles from './styles.module.scss'

type IMessageDetailsModalContentProps = {
  store: MessageDetailsModalStore
}

export const MessageDetailsModalContent = observer(
  ({ store }: IMessageDetailsModalContentProps) => {
    const { loading, messageDetails, message } = store
    const { statusDisplayName, date, body, media } = message
    const { twilio_url, created_at, message_SID } = messageDetails || {}
    const twilioSID = twilio_url?.split('/').pop()

    if (loading)
      return (
        <div className={styles.wrapper}>
          <SpinnerLoader ariaLabel={'MessageDetailsModalContent'} />
        </div>
      )

    return (
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <Typography variant={'body-rg-regular'} ariaLabel={'MessageDetailsStatus'}>
            {statusDisplayName}
          </Typography>
          <Typography variant={'heading-lg'} ariaLabel={'MessageDetailsDate'}>
            {uiStore.dayjs(date).format(DayjsFormats.fullWithAtLong)}
          </Typography>
        </div>
        <MessageContent message={body} attachments={media} type='sms' />
        <div className={styles.details}>
          <Typography variant={'body-rg-medium'} className={styles.title} ariaLabel={'Properties'}>
            Properties
          </Typography>
          <div className={styles.grid}>
            <Typography
              variant={'text-input-field'}
              className={styles.label}
              ariaLabel={'TwilioSIDLabel'}
            >
              Twilio SID
            </Typography>
            <div className={styles.value}>
              {twilio_url ? (
                <>
                  <Typography
                    variant={'text-input-field-r'}
                    textDecoration={'none'}
                    ariaLabel={'TwilioSIDValue'}
                    pointer
                    link
                  >
                    <a href={twilio_url} target='_blank' rel='noreferrer'>
                      {twilioSID}
                    </a>
                  </Typography>
                  <IconCopyButton value={twilioSID} />
                </>
              ) : (
                <Typography ariaLabel={'TwilioSIDNoValue'} variant={'text-input-field'}>
                  -
                </Typography>
              )}
            </div>
          </div>
          <div className={styles.grid}>
            <Typography
              variant={'text-input-field'}
              className={styles.label}
              ariaLabel={'MessageSIDLabel'}
            >
              Message SID
            </Typography>
            <div className={styles.value}>
              <Typography ariaLabel={'MessageSIDValue'} variant={'text-input-field'}>
                {message_SID ?? '-'}
              </Typography>
              {message_SID && <IconCopyButton value={message_SID} />}
            </div>
          </div>
          <div className={styles.grid}>
            <Typography
              variant={'text-input-field'}
              className={styles.label}
              ariaLabel={'CreatedAtLabel'}
            >
              Created At
            </Typography>
            <div className={styles.value}>
              <Typography variant={'text-input-field'} ariaLabel={'CreatedAtValue'}>
                {created_at ? uiStore.dayjs(created_at).format(DayjsFormats.fullWithTimezone) : '-'}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    )
  }
)
